<template>
  <div class="rent-location-bd">
    <div class="wrap">
      <div class="per-wrap">
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item v-if="funcView.func_bind_location">
              <el-button type="primary" icon="el-icon-plus" @click="onBind()">{{ funcView.func_bind_location }}</el-button>
            </el-form-item>
            <el-form-item>
            <el-button type="primary" v-if="funcView.func_unbind_location" :disabled="!selectedData.length" @click="onDeleteRows()" >{{$t('Common.com_delete')}}</el-button>
          </el-form-item>
            <!-- 配置项 -->
            <el-form-item style="float: right; margin-right: 0">
              <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
            </el-form-item>
            <!-- 搜索项 -->
            <el-form-item style="float: right">
              <el-input :placeholder="$t('crm_rent_location.gong_si_ming_cheng')" v-model="formSearch.orgName" clearable @keyup.enter.native="onPageChange({ page: 1 })" style="width: 280px">
                <template slot="append">
                  <div @click="onPageChange({ page: 1 })">
                    <i class="icon icon-search"></i>
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item style="float: right">
              <el-input :placeholder="$t('crm_rent_location.xiang_mu_ming_cheng')" v-model="formSearch.search" clearable @keyup.enter.native="onPageChange({ page: 1 })" style="width: 280px">
                <template slot="append">
                  <div @click="onPageChange({ page: 1 })">
                    <i class="icon icon-search"></i>
                  </div>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-bd">
          <custom-table
            v-if="funcView.func_location_list"
            ref="tb1"
            v-loading="isLoading"
            border
            type="checkbox"
            v-model="selectedData"
            row-key="menuId"
            :size="allTableSize"
            :column="tableColumn"
            :data="rentList"
            :default-expand-all="true"
            height="100%"
            @selection-change="selectionChange"
            @sort-change="sortChange"
            @filter-change="filterChange"
            :slots="['action']"
            selectableKey="isAuto"
          >

            <template slot="action" slot-scope="scope">
              <span></span>
              <el-button v-if="funcView.func_unbind" type="text" size="mini" @click="deleteRenter(scope.row)">{{ funcView.func_unbind }}</el-button>
              <!-- <el-button type="text" size="mini" @click="lesseeEquipment(scope.row)" v-if="`${scope.row.relationType}` === '0' && funcView.func_bind">{{ funcView.func_bind }}</el-button> -->
            </template>
          </custom-table>
        </div>
        <div class="table-page">
          <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </div>
    </div>

    <!-- 关联项目 -->
    <lessee-location-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getRenterList"></lessee-location-dialog>
  </div>
</template>
<script>
import apis from '@/utils/apis';

import lesseeLocationDialog from './lessee_location_dialog.vue';

export default {
  components: { lesseeLocationDialog },
  props: {
    type: {
      type: String,
      default: 'page',
    },
    roleData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tableCode: 'rent_location',
      app: {},
      rentList: [],
      isLoading: false,
      selectedData: [],
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        // partnerId: '',
        bizId: '',
        bizType: 1,
        orgType: 'CS',
        orgName: '',
        locationName: '',
        isAss: 1
      },
      totalRows: 0,

      // 设备弹窗
      dialogVisible: false,
      dialogModel: {},

    };
  },

  watch: {
    roleData: function () {
      this.dialogModel.data = this.roleData;
      this.getRenterList();
    },
  },
  mounted() {
    this.getTableColumn();
    this.getRenterList();
    this.getFuncView('/customer/groupRelation');
    // this.isLoading = true;
  },
  methods: {
    // 获取应用菜单树
    getRenterList: function () {
      // this.formSearch.partnerId = this.roleData.partnerId;
      this.formSearch.bizId = this.roleData.partnerOrgId;
      this.$getJSON(apis.bizLocationPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.rentList = res.data.list || [];
        this.totalRows = res.data.total;
      });

    },

    // 关联项目
    onBind: function () {
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('crm_rent_location.guan_lian_xiang_mu');
      this.dialogModel.type = 'location';
      this.dialogModel.data = this.roleData;
      this.dialogModel.largeCustomerId = this.roleData.partnerOrgId;
    },

    // 删除多个
    onDeleteRows() {
      const tips = this.$t('crm_rent_location.nqdyscdqxzdxmm');
      const partnerOrgId = this.roleData.partnerOrgId;

      // 使用 map 方法整理数组
      const newSelectedLocationData = this.selectedData.map(item => ({
        bizId: partnerOrgId,
        orgId: partnerOrgId, // 设定 orgId 为 partnerOrgId
        toBizId: item.locationId, // 将 bizId 设置为 item 的 locationId
        bizType: 1, // 添加 bizType 为 1
        toBizType: 4, // 添加 toBizType 为 4
      }));
      this.$showConfirm(tips).then(() => {
        this.$postJSON(apis.deviceBindAutomaticBatchDelete, newSelectedLocationData).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success'
          });
          this.getRenterList();
        });
      })
        .catch(() => { });
    },
    // 切换页
    onCurrentPage: function (page) {
      this.formSearch.pageNum = page;
      this.getRenterList();
    },
    // 切换每页数量
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getRenterList();
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getRenterList();
    },
  },
};
</script>

<style lang="scss">
.rent-location-bd {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 0;
  .wrap {
    padding: 20px;
    display: flex;
    flex: 1;
    height: 0;
  }
  .per-aside {
    width: 150px;
    margin-right: 20px;
    ul li {
      line-height: 34px;
      height: 34px;
      text-align: center;
      color: #727272;
      font-size: 12px;
      border-radius: 2px 0px 0px 2px;
      overflow: hidden;
      border: 1px solid #e4e4e4;
      margin-bottom: 8px;
      cursor: pointer;
      &.cur {
        color: #ffffff;
        background: #00a2df;
        border: 1px solid #00a2df;
      }
    }
  }
  .per-wrap {
    flex: 1;
    width: 0;
    display: flex;
    flex-direction: column;
    .el-checkbox__label {
      color: #262626;
      line-height: 23px;
      font-weight: normal;
      font-size: 12px;
    }
    .checkall {
      display: flex;
      align-items: center;
      padding-right: 15px;
      margin-right: 15px;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        right: 0;
        top: 2px;
        bottom: 2px;
        width: 1px;
        background-color: #e4e4e4;
      }
    }
  }
}
</style>
